<template>
  <div class="agreement">
    <div v-if="protocolContent.length > 0">
      <div class="item-wrap">
        <div class="item" v-for="(item, index) in protocolContent" :key="index">
           <div class="content" v-html="item.configValue"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getProtocol } from "@/api/index.js";

export default {
  name: "agreement",
  data() {
    return {
      protocolContent: []
    };
  },
  async mounted() {
    let agrType = this.$route.query.ageType || '3'
    let params = {
      type: agrType
    }
    getProtocol(params).then((res) => {
      if (res.code === 2000) {
        this.protocolContent = res.data;
      } else {
        this.$toast(res.msg || res.message || "请求失败");
      }
    });
  },
  methods: {
   
   
    
  },
};
</script>

<style scoped lang="scss">
.agreement {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow-y: auto;
  background: #fff;
  word-break: break-all;
  overflow-wrap: break-word;
}
.item-wrap{
  padding: 16px;
}
</style>
